module.exports = __webpack_public_path__ + "static/media/banner-d.c2e6b639.jpg";